import { render, staticRenderFns } from "./SOFA.vue?vue&type=template&id=2e095d90&scoped=true"
import script from "./SOFA.vue?vue&type=script&lang=js"
export * from "./SOFA.vue?vue&type=script&lang=js"
import style0 from "./SOFA.vue?vue&type=style&index=0&id=2e095d90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e095d90",
  null
  
)

export default component.exports